import { render, staticRenderFns } from "./TerimaPaket.vue?vue&type=template&id=74fde2cc&"
import script from "./TerimaPaket.vue?vue&type=script&lang=js&"
export * from "./TerimaPaket.vue?vue&type=script&lang=js&"
import style0 from "./TerimaPaket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports